/**
 * @generated SignedSource<<3581085c27440cf1ddd2beb3e781dc03>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { UpdatableFragment, ReaderFragment } from 'relay-runtime';
export type InspectionfieldStateEnum = "APPROVED" | "ASSIGNED" | "IN_PROGRESS" | "OPEN" | "PLANNED" | "REJECTED" | "RETRY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type QueriesInspectionListUpdatable$data = {
  plannedDate: any | null;
  state: InspectionfieldStateEnum | null;
  readonly " $fragmentType": "QueriesInspectionListUpdatable";
};
export type QueriesInspectionListUpdatable$key = {
  readonly " $data"?: QueriesInspectionListUpdatable$data;
  readonly $updatableFragmentSpreads: FragmentRefs<"QueriesInspectionListUpdatable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QueriesInspectionListUpdatable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedDate",
      "storageKey": null
    }
  ],
  "type": "InspectionfieldNode",
  "abstractKey": null
};

(node as any).hash = "78d603e72eba6a9d38f0bbec35bbc4fe";

export default node;
